// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3z6De","buttons":"PendingPaymentAlert_buttons__2FsyF"};